/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Check,
  CheckInput,
  Fleet,
  FleetCreateInput,
  FleetInvitesList,
  FleetModelCountsStats,
  FleetPublicVehicles,
  FleetUpdateInput,
  FleetVehicleExportsList,
  FleetVehicles,
  FleetVehiclesExportParams,
  FleetVehiclesHangarLinkExportParams,
  FleetVehiclesParams,
  FleetsList,
  PublicFleetStatsModelCountsParams,
  PublicFleetVehiclesEmbedParams,
  PublicFleetVehiclesParams,
  PublicVehiclesList,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create Fleet
 */
export const createFleet = (
    fleetCreateInput: MaybeRefOrGetter<FleetCreateInput>,
 signal?: AbortSignal
) => {
      fleetCreateInput = toValue(fleetCreateInput);

      return axiosClient<Fleet>(
      {url: `/fleets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetCreateInput, signal
    },
      );
    }




export const getCreateFleetMutationKey = () => ['createFleet'] as const;

export const getCreateFleetMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleet>>, TError,CreateFleetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleet>>, TError,CreateFleetMutationVariables, TContext> => {

const mutationKey = getCreateFleetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleet>>, CreateFleetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createFleet(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetMutationResult = NonNullable<Awaited<ReturnType<typeof createFleet>>>
    export type CreateFleetMutationBody = FleetCreateInput
    export type CreateFleetMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFleetMutationVariables = {data: FleetCreateInput}

    /**
 * @summary Create Fleet
 */
export const useCreateFleet = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleet>>, TError,CreateFleetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleet>>,
        TError,
        CreateFleetMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetMutationOptions(options), queryClient);
    }
    /**
 * @summary Check Fleet FID Availability
 */
export const checkFID = (
    checkInput: MaybeRefOrGetter<CheckInput>,
 signal?: AbortSignal
) => {
      checkInput = toValue(checkInput);

      return axiosClient<Check>(
      {url: `/fleets/check`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkInput, signal
    },
      );
    }




export const getCheckFIDMutationKey = () => ['checkFID'] as const;

export const getCheckFIDMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkFID>>, TError,CheckFIDMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof checkFID>>, TError,CheckFIDMutationVariables, TContext> => {

const mutationKey = getCheckFIDMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkFID>>, CheckFIDMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  checkFID(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckFIDMutationResult = NonNullable<Awaited<ReturnType<typeof checkFID>>>
    export type CheckFIDMutationBody = CheckInput
    export type CheckFIDMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CheckFIDMutationVariables = {data: CheckInput}

    /**
 * @summary Check Fleet FID Availability
 */
export const useCheckFID = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkFID>>, TError,CheckFIDMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof checkFID>>,
        TError,
        CheckFIDMutationVariables,
        TContext
      > => {
      return useMutation(getCheckFIDMutationOptions(options), queryClient);
    }
    /**
 * @summary Find Fleet by Invite
 */
export const findFleetByInvite = (
    token: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      token = toValue(token);

      return axiosClient<Fleet>(
      {url: `/fleets/find-by-invite/${token}`, method: 'POST', signal
    },
      );
    }




export const getFindFleetByInviteMutationKey = () => ['findFleetByInvite'] as const;

export const getFindFleetByInviteMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof findFleetByInvite>>, TError,FindFleetByInviteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof findFleetByInvite>>, TError,FindFleetByInviteMutationVariables, TContext> => {

const mutationKey = getFindFleetByInviteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof findFleetByInvite>>, FindFleetByInviteMutationVariables> = (props) => {
          const {token} = props ?? {};

          return  findFleetByInvite(token,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FindFleetByInviteMutationResult = NonNullable<Awaited<ReturnType<typeof findFleetByInvite>>>

    export type FindFleetByInviteMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type FindFleetByInviteMutationVariables = {token: string}

    /**
 * @summary Find Fleet by Invite
 */
export const useFindFleetByInvite = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof findFleetByInvite>>, TError,FindFleetByInviteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof findFleetByInvite>>,
        TError,
        FindFleetByInviteMutationVariables,
        TContext
      > => {
      return useMutation(getFindFleetByInviteMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Invites current User
 */
export const fleetInvites = (

 signal?: AbortSignal
) => {


      return axiosClient<FleetInvitesList>(
      {url: `/fleets/invites`, method: 'GET', signal
    },
      );
    }




export const getFleetInvitesQueryKey = () => {
    return [
    'fleets','invites'
    ] as const;
    }


export const getFleetInvitesQueryOptions = <TData = Awaited<ReturnType<typeof fleetInvites>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInvites>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetInvitesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetInvites>>> = ({ signal }) => fleetInvites(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetInvites>>, TError, TData>
}

export type FleetInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof fleetInvites>>>
export type FleetInvitesQueryError = ErrorType<StandardError>


/**
 * @summary Fleet Invites current User
 */

export function useFleetInvites<TData = Awaited<ReturnType<typeof fleetInvites>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInvites>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetInvitesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleets for current User
 */
export const myFleets = (

 signal?: AbortSignal
) => {


      return axiosClient<FleetsList>(
      {url: `/fleets/my`, method: 'GET', signal
    },
      );
    }




export const getMyFleetsQueryKey = () => {
    return [
    'fleets','my'
    ] as const;
    }


export const getMyFleetsQueryOptions = <TData = Awaited<ReturnType<typeof myFleets>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myFleets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getMyFleetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof myFleets>>> = ({ signal }) => myFleets(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof myFleets>>, TError, TData>
}

export type MyFleetsQueryResult = NonNullable<Awaited<ReturnType<typeof myFleets>>>
export type MyFleetsQueryError = ErrorType<StandardError>


/**
 * @summary Fleets for current User
 */

export function useMyFleets<TData = Awaited<ReturnType<typeof myFleets>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myFleets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMyFleetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Vehicles List
 */
export const fleetVehicles = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetVehiclesParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetVehicles>(
      {url: `/fleets/${fleetSlug}/vehicles`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetVehiclesQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetVehiclesParams>,) => {
    return [
    'fleets',fleetSlug,'vehicles', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetVehiclesQueryOptions = <TData = Awaited<ReturnType<typeof fleetVehicles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetVehiclesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetVehicles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetVehiclesQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetVehicles>>> = ({ signal }) => fleetVehicles(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetVehicles>>, TError, TData>
}

export type FleetVehiclesQueryResult = NonNullable<Awaited<ReturnType<typeof fleetVehicles>>>
export type FleetVehiclesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Vehicles List
 */

export function useFleetVehicles<TData = Awaited<ReturnType<typeof fleetVehicles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetVehiclesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetVehicles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetVehiclesQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Vehicles List
 */
export const fleetVehiclesExport = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetVehiclesExportParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetVehicleExportsList>(
      {url: `/fleets/${fleetSlug}/vehicles/export`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetVehiclesExportQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetVehiclesExportParams>,) => {
    return [
    'fleets',fleetSlug,'vehicles','export', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetVehiclesExportQueryOptions = <TData = Awaited<ReturnType<typeof fleetVehiclesExport>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetVehiclesExportParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetVehiclesExport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetVehiclesExportQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetVehiclesExport>>> = ({ signal }) => fleetVehiclesExport(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetVehiclesExport>>, TError, TData>
}

export type FleetVehiclesExportQueryResult = NonNullable<Awaited<ReturnType<typeof fleetVehiclesExport>>>
export type FleetVehiclesExportQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Vehicles List
 */

export function useFleetVehiclesExport<TData = Awaited<ReturnType<typeof fleetVehiclesExport>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetVehiclesExportParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetVehiclesExport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetVehiclesExportQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Export a Fleet for hangar.link
 */
export const fleetVehiclesHangarLinkExport = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetVehiclesHangarLinkExportParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetVehicleExportsList>(
      {url: `/fleets/${fleetSlug}/vehicles/export/hangar-link`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetVehiclesHangarLinkExportQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetVehiclesHangarLinkExportParams>,) => {
    return [
    'fleets',fleetSlug,'vehicles','export','hangar-link', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetVehiclesHangarLinkExportQueryOptions = <TData = Awaited<ReturnType<typeof fleetVehiclesHangarLinkExport>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetVehiclesHangarLinkExportParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetVehiclesHangarLinkExport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetVehiclesHangarLinkExportQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetVehiclesHangarLinkExport>>> = ({ signal }) => fleetVehiclesHangarLinkExport(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetVehiclesHangarLinkExport>>, TError, TData>
}

export type FleetVehiclesHangarLinkExportQueryResult = NonNullable<Awaited<ReturnType<typeof fleetVehiclesHangarLinkExport>>>
export type FleetVehiclesHangarLinkExportQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Export a Fleet for hangar.link
 */

export function useFleetVehiclesHangarLinkExport<TData = Awaited<ReturnType<typeof fleetVehiclesHangarLinkExport>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetVehiclesHangarLinkExportParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetVehiclesHangarLinkExport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetVehiclesHangarLinkExportQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Fleet
 */
export const destroyFleet = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<void>(
      {url: `/fleets/${slug}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetMutationKey = () => ['destroyFleet'] as const;

export const getDestroyFleetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleet>>, TError,DestroyFleetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleet>>, TError,DestroyFleetMutationVariables, TContext> => {

const mutationKey = getDestroyFleetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleet>>, DestroyFleetMutationVariables> = (props) => {
          const {slug} = props ?? {};

          return  destroyFleet(slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleet>>>

    export type DestroyFleetMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetMutationVariables = {slug: string}

    /**
 * @summary Destroy Fleet
 */
export const useDestroyFleet = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleet>>, TError,DestroyFleetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleet>>,
        TError,
        DestroyFleetMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Detail
 */
export const fleet = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<Fleet>(
      {url: `/fleets/${slug}`, method: 'GET', signal
    },
      );
    }




export const getFleetQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',slug
    ] as const;
    }


export const getFleetQueryOptions = <TData = Awaited<ReturnType<typeof fleet>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleet>>> = ({ signal }) => fleet(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleet>>, TError, TData>
}

export type FleetQueryResult = NonNullable<Awaited<ReturnType<typeof fleet>>>
export type FleetQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Detail
 */

export function useFleet<TData = Awaited<ReturnType<typeof fleet>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Fleet
 */
export const updateFleet = (
    slug: MaybeRefOrGetter<string>,
    fleetUpdateInput: MaybeRefOrGetter<FleetUpdateInput>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);
fleetUpdateInput = toValue(fleetUpdateInput);

      return axiosClient<Fleet>(
      {url: `/fleets/${slug}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetUpdateInput, signal
    },
      );
    }




export const getUpdateFleetMutationKey = () => ['updateFleet'] as const;

export const getUpdateFleetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleet>>, TError,UpdateFleetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleet>>, TError,UpdateFleetMutationVariables, TContext> => {

const mutationKey = getUpdateFleetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleet>>, UpdateFleetMutationVariables> = (props) => {
          const {slug,data} = props ?? {};

          return  updateFleet(slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleet>>>
    export type UpdateFleetMutationBody = FleetUpdateInput
    export type UpdateFleetMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateFleetMutationVariables = {slug: string;data: FleetUpdateInput}

    /**
 * @summary Update Fleet
 */
export const useUpdateFleet = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleet>>, TError,UpdateFleetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleet>>,
        TError,
        UpdateFleetMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetMutationOptions(options), queryClient);
    }
    /**
 * @summary Public Fleet Stats Model Counts
 */
export const publicFleetStatsModelCounts = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetStatsModelCountsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetModelCountsStats>(
      {url: `/public/fleets/${fleetSlug}/stats/model-counts`, method: 'GET',
        params, signal
    },
      );
    }




export const getPublicFleetStatsModelCountsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetStatsModelCountsParams>,) => {
    return [
    'public','fleets',fleetSlug,'stats','model-counts', ...(params ? [params] : [])
    ] as const;
    }


export const getPublicFleetStatsModelCountsQueryOptions = <TData = Awaited<ReturnType<typeof publicFleetStatsModelCounts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetStatsModelCountsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetStatsModelCounts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetStatsModelCountsQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleetStatsModelCounts>>> = ({ signal }) => publicFleetStatsModelCounts(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleetStatsModelCounts>>, TError, TData>
}

export type PublicFleetStatsModelCountsQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleetStatsModelCounts>>>
export type PublicFleetStatsModelCountsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Fleet Stats Model Counts
 */

export function usePublicFleetStatsModelCounts<TData = Awaited<ReturnType<typeof publicFleetStatsModelCounts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetStatsModelCountsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetStatsModelCounts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetStatsModelCountsQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Fleet Vehicles List
 */
export const publicFleetVehicles = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetVehiclesParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetPublicVehicles>(
      {url: `/public/fleets/${fleetSlug}/vehicles`, method: 'GET',
        params, signal
    },
      );
    }




export const getPublicFleetVehiclesQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetVehiclesParams>,) => {
    return [
    'public','fleets',fleetSlug,'vehicles', ...(params ? [params] : [])
    ] as const;
    }


export const getPublicFleetVehiclesQueryOptions = <TData = Awaited<ReturnType<typeof publicFleetVehicles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetVehiclesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetVehicles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetVehiclesQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleetVehicles>>> = ({ signal }) => publicFleetVehicles(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleetVehicles>>, TError, TData>
}

export type PublicFleetVehiclesQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleetVehicles>>>
export type PublicFleetVehiclesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Fleet Vehicles List
 */

export function usePublicFleetVehicles<TData = Awaited<ReturnType<typeof publicFleetVehicles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetVehiclesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetVehicles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetVehiclesQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Fleet Vehicles Embed for the Fleetyards Widget
 */
export const publicFleetVehiclesEmbed = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetVehiclesEmbedParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<PublicVehiclesList>(
      {url: `/public/fleets/${fleetSlug}/vehicles/embed`, method: 'GET',
        params, signal
    },
      );
    }




export const getPublicFleetVehiclesEmbedQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetVehiclesEmbedParams>,) => {
    return [
    'public','fleets',fleetSlug,'vehicles','embed', ...(params ? [params] : [])
    ] as const;
    }


export const getPublicFleetVehiclesEmbedQueryOptions = <TData = Awaited<ReturnType<typeof publicFleetVehiclesEmbed>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetVehiclesEmbedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetVehiclesEmbed>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetVehiclesEmbedQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleetVehiclesEmbed>>> = ({ signal }) => publicFleetVehiclesEmbed(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleetVehiclesEmbed>>, TError, TData>
}

export type PublicFleetVehiclesEmbedQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleetVehiclesEmbed>>>
export type PublicFleetVehiclesEmbedQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Fleet Vehicles Embed for the Fleetyards Widget
 */

export function usePublicFleetVehiclesEmbed<TData = Awaited<ReturnType<typeof publicFleetVehiclesEmbed>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetVehiclesEmbedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetVehiclesEmbed>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetVehiclesEmbedQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Detail
 */
export const publicFleet = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<Fleet>(
      {url: `/public/fleets/${slug}`, method: 'GET', signal
    },
      );
    }




export const getPublicFleetQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'public','fleets',slug
    ] as const;
    }


export const getPublicFleetQueryOptions = <TData = Awaited<ReturnType<typeof publicFleet>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleet>>> = ({ signal }) => publicFleet(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleet>>, TError, TData>
}

export type PublicFleetQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleet>>>
export type PublicFleetQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Detail
 */

export function usePublicFleet<TData = Awaited<ReturnType<typeof publicFleet>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






